import React from 'react';
import Icon from 'components/AppIcon';

const PersonalInfoSection = ({ formData, errors, isArabic, onInputChange }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
          <Icon name="User" size={20} color="#16a34a" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          {isArabic ? 'المعلومات الشخصية' : 'Personal Information'}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Full Name */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'الاسم الكامل' : 'Full Name'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => onInputChange('name', e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
              errors.name ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder={isArabic ? 'أدخل الاسم الكامل' : 'Enter full name'}
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.name}
            </p>
          )}
        </div>


        {/* Phone Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'رقم الهاتف' : 'Phone Number'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="tel"
            value={formData.phone}
            onChange={(e) => onInputChange('phone', e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
              errors.phone ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder={isArabic ? 'أدخل رقم الهاتف' : 'Enter phone number'}
          />
          {errors.phone && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.phone}
            </p>
          )}
        </div>

        {/* Address */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'العنوان' : 'Address'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <textarea
            value={formData.address}
            onChange={(e) => onInputChange('address', e.target.value)}
            rows={3}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 resize-none ${
              errors.address ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder={isArabic ? 'أدخل العنوان الكامل' : 'Enter full address'}
          />
          {errors.address && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.address}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;